const isLanguageRTL = (langCode?: string): boolean => {
  if (!langCode) return false

  const rtlLangCodes: string[] = ['ar', 'he', 'fa', 'ur', 'ps', 'sd', 'dv', 'yi']

  return rtlLangCodes.includes(langCode.toLowerCase())
}

export default isLanguageRTL
